import { createApp } from '@/calculator';
import { i18nSetPublicLocale } from '@/i18n';

const { app, store } = createApp();
const element = document.getElementById('calculator-app');
const { language } = element.dataset;
i18nSetPublicLocale(language)
    .then(() => app.$mount('#calculator-app'));

